import React, { useEffect, useRef, useState, lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import LoadingBar from 'react-top-loading-bar';
import { setLoadingFunctions } from './http/HttpRequest';
import CommonLoader from './loader/CommonLoader';
import TitleManager from './TitleManager';

const PublicRoutes = lazy(() => import('./components/frontend/PublicRoutes'));
const AdminRoutes = lazy(() => import('./components/admin/AdminRoutes'));
const Login = lazy(() => import('./components/auth/Login'));
const Error404 = lazy(() => import('./components/Error404'));


function App() {
  const topLoadingBarRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setLoadingFunctions({
      startLoading: () => {
        setIsLoading(true);
        if (topLoadingBarRef.current) {
          topLoadingBarRef.current.continuousStart();
        }
      },
      completeLoading: () => {
        setIsLoading(false);
        if (topLoadingBarRef.current) {
          topLoadingBarRef.current.complete();
        }
      }
    });
  }, []);

  return (
    <>
      <LoadingBar ref={topLoadingBarRef} color="#4B49AC" />
      {isLoading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >         
        </div>
      )}
      <Router>
        <Suspense fallback={<CommonLoader/>}>        
          <Routes>
            <Route exact path="/*" element={<PublicRoutes />} />
            <Route path="/login" element={<Login />} />
            <Route path="/root/*" element={<AdminRoutes />} />
            <Route path="*" element={<Error404 />} />
          </Routes>
        </Suspense>
      </Router>
    </>
  );
}

export default App;
